// extracted by mini-css-extract-plugin
export default {"container":"sH-z","disabled":"tH-z","bgBlack":"uH-z","content":"vH-z","countdown":"wH-z","topCaption":"xH-z","topHeading":"yH-z","heading":"zH-z","copy":"AH-z"};